import React from "react";
import { Stack } from "react-bootstrap";
import { PageHeader } from "../../../CommonElements/PageTitle";
import { useTranslation } from "react-i18next";
import { useSearchParams } from "react-router-dom";
import { Tabs } from "antd";
import { HugeiconsIcon } from "@hugeicons/react";
import {
  AirplaneLanding01Icon,
  Calendar02Icon,
} from "@hugeicons/core-free-icons/index";
import { Container } from "reactstrap";
import { MadinaReceptionList } from "./MadinahReceptionList";
import { MED_RECEPTION_TABS } from "@/utils/constants";

export const ReceptionMadina = () => {
  const { t } = useTranslation();
  const [searchParams, setSearchParams] = useSearchParams();
  const currentSource = searchParams.get("date") || "today";

  const handleTabChange = (key) => {
    setSearchParams({ date: key });
  };

  const tabItems = [
    {
      ...MED_RECEPTION_TABS.today,
      icon: <HugeiconsIcon size={16} icon={Calendar02Icon} />,
    },
    {
      ...MED_RECEPTION_TABS.all,
      icon: <HugeiconsIcon size={16} icon={AirplaneLanding01Icon} />,
    },
  ];

  return (
    <Stack gap={3}>
      <PageHeader title={t("RECEPTION_MADINAH")} sticky={false} />
      <Container fluid>
        <Tabs
          activeKey={currentSource}
          defaultActiveKey="today"
          items={tabItems.map((tab) => ({
            ...tab,
            label: t(tab.label),
          }))}
          onChange={handleTabChange}
          className="mb-3"
        />
        <MadinaReceptionList port="MED" />
      </Container>
    </Stack>
  );
};
